export const EnumAIResponseType = {
  DepartmentFound: 0,
  DepartmentNotFound: 1,
  SuitableDepartmentByFilterNotFound: 2,
  AlternateHospitals: 3,
};

// backend enumlar
//  None = 0
//  Subscription = 1, Aylık abonelik
//  Annual = 2,  yıllık abonelik
//  InsuranceSubscription = 3, sigortalı aylık abonelik
//  InsuranceAnnual = 4 sigortalı yıllık abonelik
export const EnumPackageGradePriceType = {
  None: 0,
  Subscription: 1,
  Annual: 2,
  InsuranceSubscription: 3,
  InsuranceAnnual: 4,
};
